export default [
    {
        "data": [
            {
                "cross_section": "43002",
                "exp": 0.3,
                "cont": 0.3
            }
        ],
        "error_id": "RT 02",
        "cs_data": [
            {
                "cross_section": "43827",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "43002",
                "cont": 0.3,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "42210",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "42157",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "42127",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "42062",
                "cont": 0.1,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "41697",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "41045",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "40415",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "39687",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "39205",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "38441",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "38042",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "37890",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "37860",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "37830",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "37372",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "36942",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "36273",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "36037",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "36007",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "35925",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "35593",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "35256",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "34502",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "33998",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "33315",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "32373",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "31673",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "31027",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "30463",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "30172",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "30117",
                "cont": null,
                "exp": null,
                "type": "Bridge",
                "section": null
            },
            {
                "cross_section": "29890",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "29369",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "28194",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "27303",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "26228",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "25116",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "23721",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "23668",
                "cont": null,
                "exp": null,
                "type": "Bridge",
                "section": null
            },
            {
                "cross_section": "23483",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "21912",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "20846",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "19690",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "18080",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "17158",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "16516",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "15460",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "13228",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "12345",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "11755",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "10566",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "9633",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "8402",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "7283",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "6412",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "4606",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "3757",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "2777",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "2233",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "2134",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "1978",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "1814",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "1236",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            }
        ],
        "exp_expected": 0.3,
        "cont_expected": 0.1
    },
    {
        "data": [
            {
                "cross_section": "42062",
                "number": 2,
                "culvert": "42127",
                "exp": 0.5,
                "cont": 0.1,
                "exp_expected": 0.5,
                "cont_expected": 0.3,
                "type": "Culvert"
            }
        ],
        "cs_data": [
            {
                "cross_section": "43827",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "43002",
                "cont": 0.3,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "42210",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "42157",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "42127",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "42062",
                "cont": 0.1,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "41697",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "41045",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "40415",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "39687",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "39205",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "38441",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "38042",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "37890",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "37860",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "37830",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "37372",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "36942",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "36273",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "36037",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "36007",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "35925",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "35593",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "35256",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "34502",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "33998",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "33315",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "32373",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "31673",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "31027",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "30463",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "30172",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "30117",
                "cont": null,
                "exp": null,
                "type": "Bridge",
                "section": null
            },
            {
                "cross_section": "29890",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "29369",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "28194",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "27303",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "26228",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "25116",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "23721",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "23668",
                "cont": null,
                "exp": null,
                "type": "Bridge",
                "section": null
            },
            {
                "cross_section": "23483",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "21912",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "20846",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "19690",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "18080",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "17158",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "16516",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "15460",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "13228",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "12345",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "11755",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "10566",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "9633",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "8402",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "7283",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "6412",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "4606",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "3757",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            },
            {
                "cross_section": "2777",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 4
            },
            {
                "cross_section": "2233",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 3
            },
            {
                "cross_section": "2134",
                "cont": null,
                "exp": null,
                "type": "Culvert",
                "section": null
            },
            {
                "cross_section": "1978",
                "cont": 0.3,
                "exp": 0.5,
                "type": "CrossSection",
                "section": 2
            },
            {
                "cross_section": "1814",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": 1
            },
            {
                "cross_section": "1236",
                "cont": 0.1,
                "exp": 0.3,
                "type": "CrossSection",
                "section": null
            }
        ],
        "error_id": "RT 01"
    }
]